import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface PageBleedProps {
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
}

/**
 * The frame of a working screen that runs to the edges under its header
 * (#2078, program #2079): the records list, the notifications list, the panes
 * of the sectioned screens. It bleeds through `PageBody fill`'s `p-6`
 * (`-mx-6 -mb-6`) to the sides and the bottom, rules off the header with a top
 * border and fills the rest of the viewport as a flex column.
 *
 * Goes straight under `PageHeader` as a child of `<PageBody fill>`. A screen
 * whose panes scroll on their own adds `overflow-hidden` via `className`.
 */
export function PageBleed({
  children,
  className,
  'data-testid': testId,
}: PageBleedProps) {
  return (
    <div
      data-testid={testId}
      className={cn(
        '-mx-6 -mb-6 flex min-h-0 flex-1 flex-col border-t border-border bg-bg',
        className
      )}
    >
      {children}
    </div>
  );
}
